module.exports = __webpack_public_path__ + "static/media/repeat-1-alt.61758aaa.svg";